<div id="line_widget_container" class="pointer" (click)="navigateToDetail()">
  @if (timeOut()) {
    <app-timeout></app-timeout>
  } @else if (loading()) {
    <div class="flex justify-content-center align-items-center h-full">
      <p-progressSpinner ariaLabel="loading" class="customProgressSpinner" />
    </div>
  }

  <canvas class="lineChart" [ngClass]="{ hide: loading() || timeOut() }" [id]="chartId()"></canvas>
</div>
